import axios from '../base/axios';
// import API_KEY from './key';

const GET_GENRES = 'flixfrenzy/redux/GET_GENRES';

// eslint-disable-next-line default-param-last
const genresReducer = (state = [], action) => {
  switch (action.type) {
    case GET_GENRES:
      return action.payload;
    default:
      return state;
  }
};

const options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI1NDVmNmQ4ZDNhZTgxY2JhNjMyMzE3YTIwZmQ2MjdlNCIsInN1YiI6IjYzZGM5ZjY0Y2U1ZDgyMDBmM2MwMzIyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.jrA0hcTz1kYEgNJvUA5KEnbHUb7nsh9Wc4FK-a6ueP4',
  },
};

export const getGenres = () => (dispatch) => {
  axios.get('genre/movie/list?language=en', options).then((res) => {
    dispatch({
      type: GET_GENRES,
      payload: res.data,
    });
  });
};

export default genresReducer;
